import { render } from "./CollapsibleSelect.vue?vue&type=template&id=d815a054&lang=pug"
import script from "./CollapsibleSelect.vue?vue&type=script&lang=js"
export * from "./CollapsibleSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__